const jobCard = {
  Days: {
    MO: 'Monday',
    TU: 'Tuesday',
    WE: 'Wednesday',
    TH: 'Thursday',
    FR: 'Friday',
    SA: 'Saturday',
    SU: 'Sunday',
  },
  LiveIn: 'Live-in',
  Flexible: 'Flexible',
  ScheduleLabel: '#{day} | #{timeRange}',
  LocationFormat: '#{neighborhood}, #{city}',
  Location: '#{neighborhood}, #{city} - #{clientName}',
  Languages: '#{languages} - #{clientName}',
  ClientOnly: '#{clientName}',
  ClientUnknown: 'Unknown Client',
  WeeklyPay: '$#{amount}/week',
  JobDetails: 'Rate: $#{amount}/week • $#{rate}/hr • #{hours} hrs/week • #{count} shifts',
  JobDetailsFlexible: 'Rate: $#{rate}/hr • Flexible schedule',
  BoxDetails: 'View Details',
  Deactivate: 'Deactivate',
  Reactivate: 'Reactivate',
  Internal: '#{count} Internal',
  Applications: '#{count} Applications',
};

export default jobCard;
